import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Button from 'components/theme/Button'
import { stepperDecrease } from 'actions/view'
import { Hidden } from '@material-ui/core'

const CancelButton = ({ history, onFirstStep , stepperDecrease}) => {
  const button = (size, fontSize) => (
    <Button
      style={fontSize ? { fontSize } : null}
      variant="outlined"
      color="secondary"
      onClick={() => {
        onFirstStep ? history.goBack() : stepperDecrease()
      }}
    >
      {onFirstStep ? 'Cancel' : 'Back'}
    </Button>
  )

  return (
    <Fragment>
      <Hidden smDown>{button('medium')}</Hidden>
      <Hidden mdUp>{button('small', 8)}</Hidden>
    </Fragment>
  )
}

export default withRouter(
  connect(
    (state) => ({
      onFirstStep: state.view.stepper === 0,
    }),
    (dispatch) => bindActionCreators({ stepperDecrease }, dispatch),
  )((props) => <CancelButton {...props} />),
)
